import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import RamiLogin from "./pages/RegLogin";
import Login from "./pages/Login";
import Navbar from "./pages/Navbar";
import InspectionRepo from "./pages/InspectionRepo";
import EventCreate from "./pages/EventCreate";
import LenderUserUpload from "./pages/LenderUserUpload";
import CarUpload from "./pages/CarUpload";
// import InspectionRepo from "./pages/InspectionRepo";
import ZoneRegManage from "./pages/EditPermission"
import Cookies from "js-cookie";
import LenderDashboard from "./pages/EventHandle";
import CarManage from "./pages/CarManage";
import WinHistory from "./pages/WinHistory";
import MasterDashboard from "./pages/MasterDashboard";
import InformationModal from "./components/InformationModal";
import PrivateLenderEventCreation from "./pages/PrivateLenderEventCreation";
import LenderCarSearch from "./pages/LenderCarSearch";
import logo from "./assets/logoInitialsTransparent.png";

const ProtectedRoute = ({ element, roles = [], ...rest }) => {
  const [isCookieReady, setIsCookieReady] = useState(false);
  const [userType, setUserType] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const location = useLocation();
  const maxRetries = 10; // Maximum number of retries

  useEffect(() => {
    let timeoutId;
    let retryCount = 0;

    const checkCookies = () => {
      const userTypeFromCookie = Cookies.get('adminUserType');
      const isAuthenticatedFromCookie = Cookies.get('adminAuthStatus') === 'true';

      console.log("Current cookie states:", userTypeFromCookie, isAuthenticatedFromCookie);

      if (userTypeFromCookie && isAuthenticatedFromCookie !== undefined) {
        setUserType(userTypeFromCookie);
        setIsAuthenticated(isAuthenticatedFromCookie);
        setIsCookieReady(true);
      } else if (retryCount < maxRetries) {
        // Retry after a delay if max retries not reached
        timeoutId = setTimeout(() => {
          retryCount++;
          checkCookies();
        }, 100); // Check every 100ms
      } else {
        console.error("Max retries reached. Cookies not available.");
        setIsCookieReady(true);
        setShowModal(true); // Show modal if cookies are not available
      }
    };

    // Reset state variables
    setIsCookieReady(false);
    setUserType(null);
    setIsAuthenticated(false);
    setShowModal(false);
    setShouldRedirect(false);

    checkCookies();

    // Cleanup function to clear the timeout
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [location]); // Re-run the effect when the location changes

  const handleCloseModal = () => {
    setShowModal(false);
    setShouldRedirect(true); // Set redirect flag after closing the modal
  };

  if (!isCookieReady) {
    // Optionally, you can render a loading spinner or message here
    return (
      <div
        style={{
          zIndex: "9999",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          position: "absolute",
        }}
      >
        <div class="container-loading">
          <img
            className="vvendu-loading"
            src={logo}
            width="100"
            alt="Loading"
          />
          <p>Loading.....</p>
        </div>
      </div>
    );
  }

  if (shouldRedirect) {
    console.log("Redirecting to login after modal close");
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (showModal) {
    return (
      <InformationModal
        isOpen={showModal}
        onClose={handleCloseModal}
        message="Your session was invalidated."
      />
    );
  }

  if (!isAuthenticated || !userType) {
    console.log("Preparing to show modal due to invalid or missing auth status or user type");
    setShowModal(true);
    return null; // Return null or a loading spinner to avoid rendering anything else
  }

  if (roles.length && !roles.includes(userType)) {
    console.log("Redirecting to dashboard due to role mismatch");
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }

  return React.cloneElement(element, { ...rest });
};

const AppContent = () => {
  const location = useLocation();

  return (
    <div className="w-100 bg-white">
      {(location.pathname !== "/" && location.pathname !== "/masterLogin") && <Navbar />}
      <Routes>
        <Route path="/" element={<RamiLogin />} />
        <Route path="/masterLogin" element={<Login />} />
        <Route
          path="/dashboard"
          element={<ProtectedRoute element={<Dashboard />} roles={["lender","dealer", "Private_Lender"]} />}
        />
        <Route
          path="/masterDashboard"
          element={<ProtectedRoute element={<MasterDashboard />} roles={["Master_Lender"]} />}
        />
        <Route
          path="/manageZoneRegion"
          element={<ProtectedRoute element={<ZoneRegManage />} roles={["Master_Lender"]} />}
        />
        <Route
          path="/lenderUpload"
          element={<ProtectedRoute element={<LenderUserUpload />} roles={["lender", "Private_lender"]} />}
        />
        <Route
          path="/eventCreation"
          element={<ProtectedRoute element={<EventCreate />} roles={["lender"]} />}
        />
        <Route
          path="/privateEvent"
          element={<ProtectedRoute element={<PrivateLenderEventCreation/>} roles={["Private_Lender"]}/>}
        />
        <Route
          path="/carSearch"
          element={<ProtectedRoute element={<LenderCarSearch/>} roles={["Private_Lender"]}/>}
        />
        <Route
          path="/lenderEvent"
          element={<ProtectedRoute element={<LenderDashboard />} roles={["lender", "Private_Lender"]} />}
        />
        <Route
          path="/carUpload"
          element={<ProtectedRoute element={<CarUpload />} roles={["dealer"]} />}
        />
        <Route
          path="/carManage"
          element={<ProtectedRoute element={<CarManage />} roles={["dealer"]} />}
        />
        <Route
          path="/winHistory"
          element={<ProtectedRoute element={<WinHistory />} roles={["dealer"]} />}
        />
        <Route
          path="/InspectionRepo"
          element={<ProtectedRoute element={<InspectionRepo />} roles={["dealer"]} />}
        />
      </Routes>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <link
        href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css"
        rel="stylesheet"
      />
      <AppContent />
    </Router>
  );
};

export default App;